import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper } from './styled';
import ActionBar from './components/ActionBar';
import Table from './components/Table';
import CreateEditModal from './components/CreateEditModal';
import CredentialDetail from './components/CredentialDetail';
import {
  selectCount,
  selectCredentialsSelected, selectDeleteConfirmation, selectError, selectErrorMessage,
  selectIsFetching,
  selectModalBulkUpdateField, selectModalBulkUpdateValue,
  selectShowCreateEditModal, selectShowDetail
} from 'store/Credentials/selectors';
import getColumns from './components/Table/columns';
import CredentialsContextMenu from './components/Table/components/ContextMenu';
import ImportCredentialModal from './components/ImportCredentialModal';
import ErrorDialog from 'Common/Components/ErrorDialog';
import { bulkUpdateCredentials, clearError } from 'store/Credentials/actions';
import BulkUpdateModal from './components/Table/components/BulkUpdateModal';
import BulkUpdateConfirmationDialog from 'Screens/Contextualization/Manage/components/ManageTable/components/BulkUpdateConfirmationDialog';
import DeleteConfirmationModal from './components/ActionBar/components/DeleteConfirmationModal';
import { getVulnsCountInWs } from 'Screens/Contextualization/Faraday/actions/Actions';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { resetFilters } from 'store/Filters/actions';

const Credentials = () => {
  const workspace = useSelector(selectCurrentWorkspace);
  const showCreateEdit = useSelector(selectShowCreateEditModal);
  const showDetail = useSelector(selectShowDetail);
  const [hidePass, setHidePass] = useState(true);
  const isFetching = useSelector(selectIsFetching);
  const columns = getColumns(hidePass, setHidePass, isFetching);
  const error = useSelector(selectError);
  const errorMessage = useSelector(selectErrorMessage);
  const dispatch = useDispatch();
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const credentialsCount = useSelector(selectCount);
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);
  const bulkUpdateField = useSelector(selectModalBulkUpdateField);
  const showDeleteModal = useSelector(selectDeleteConfirmation);

  useEffect(() => {
    dispatch(getVulnsCountInWs());
  }, [dispatch, workspace]);

  useEffect(() => () => {
    dispatch(resetFilters('credentials'));
  }, [dispatch]);

  return (
    <Wrapper>
      <CredentialsContextMenu />
      <ActionBar withActions />
      <Table columns={ columns } hidePass={ hidePass } setHidePass={ setHidePass } />
      { showCreateEdit && <CreateEditModal /> }
      { showDetail && <CredentialDetail /> }
      <ImportCredentialModal />
      { error && <ErrorDialog message={ errorMessage } resetError={ () => dispatch(clearError()) } /> }
      <BulkUpdateModal />
      <BulkUpdateConfirmationDialog
        selected={ credentialsSelected }
        count={ credentialsCount }
        isFetching={ isFetching }
        bulkUpdateValue={ bulkUpdateValue }
        bulkUpdateAction={ bulkUpdateCredentials }
        bulkUpdateField={ bulkUpdateField }
        title="Credentials"
      />
      { showDeleteModal && <DeleteConfirmationModal /> }
    </Wrapper>
  );
};

export default Credentials;
